var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "User - Plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-390.000000, -553.000000)",
    stroke: "currentColor",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "User---Plus",
    transform: "translate(391.000000, 554.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,7.5 C8.5707,7.5 10.2499952,5.82065 10.2499952,3.75 C10.2499952,1.67852 8.5707,0 6.5,0 C4.42937,0 2.7499952,1.67852 2.7499952,3.75 C2.74258,5.8132 4.41034,7.4926 6.4735,7.5 L6.5,7.5 Z",
    id: "Path",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,16.5 C2.99449,16.5 0,16.0256 0,14.1265 C0,12.2273 2.97518,10.5 6.5,10.5 C10.0055,10.5 13,12.2109 13,14.1092 C13,16.0075 10.0248,16.5 6.5,16.5 Z",
    id: "Path",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 6,
    x2: 14.5,
    y2: 11,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 8.5,
    x2: 12,
    y2: 8.5,
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd);
export default __webpack_public_path__ + "static/media/person_add.2d6643d98fe18d1dfb7c00d99d8a96fd.svg";
export { ForwardRef as ReactComponent };